var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"analytics-guest-footer"},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('analytics.powered-by'))+" ")]),_c('LogoAnchor')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }